import React from 'react';
import { MapPin, MessageCircle, Utensils } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cda4d3ce-07c4-4663-8a1d-3cb128cb90cd/artifacts/ybet6u5o_cosme-alberdi-logo.jpg';

const Hero = () => {
  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center pt-16 md:pt-20 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-[#0d0d0d]">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0d0d] via-[#1a1a1a]/50 to-[#0d0d0d]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="flex flex-col items-center text-center">
          {/* Logo */}
          <div className="mb-8 animate-fade-in-up">
            <img 
              src={LOGO_URL} 
              alt="Cosme Alberdi" 
              className="w-32 h-32 md:w-44 md:h-44 rounded-full shadow-2xl shadow-[#7cb342]/20"
            />
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 animate-fade-in-up animation-delay-100">
            Cosme <span className="text-[#7cb342]">Alberdi</span>
          </h1>

          {/* Subtitle */}
          <p className="font-heading text-lg sm:text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-6 animate-fade-in-up animation-delay-200">
            Pub & Restaurante
          </p>

          {/* Description */}
          <p className="font-body text-gray-300 text-base sm:text-lg max-w-2xl mb-8 animate-fade-in-up animation-delay-300">
            Pizzas a la parrilla, picadas generosas, cervezas artesanales y la mejor atención en el corazón de Rosario.
          </p>

          {/* Info badges */}
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-10 animate-fade-in-up animation-delay-300">
            <div className="flex items-center gap-2 bg-[#1a1a1a] px-4 py-2 rounded-full">
              <MapPin size={16} className="text-[#7cb342]" />
              <span className="text-sm text-gray-300">Blvd. Rondeau 1602, Rosario</span>
            </div>
            <div className="flex items-center gap-2 bg-[#1a1a1a] px-4 py-2 rounded-full">
              <Utensils size={16} className="text-[#7cb342]" />
              <span className="text-sm text-gray-300">4.5 ★ (4.605 opiniones)</span>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto animate-fade-in-up animation-delay-300">
            <a
              href="https://wa.me/5493416802275"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-heading uppercase tracking-wider font-semibold"
            >
              <MessageCircle size={20} />
              WhatsApp
            </a>
            <a
              href="https://www.google.com/maps/dir//Blvd.+Rondeau+1602,+S2000+Rosario,+Santa+Fe,+Argentina"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-heading uppercase tracking-wider font-semibold"
            >
              <MapPin size={20} />
              Cómo llegar
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-[#7cb342]/50 flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-[#7cb342] rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
